/**
 * Video with Content Section
 * Handles lazy loading of videos with vanilla-lazyload
 * and video playback controls
 */

function initVideoWithContent() {
  // Initialize LazyLoad if available
  if (typeof LazyLoad !== 'undefined') {
    let lazyLoadInstance = new LazyLoad();
    window.addEventListener(
      'LazyLoad::Initialized',
      function (event) {
        window.lazyLoadInstance = event.detail.instance;
      },
      false
    );
  }

  // Get all video containers
  const videoContainers = document.querySelectorAll('.video-with-content__video-container');

  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const iframe = container.querySelector('iframe');
    const playBtn = container.querySelector('.video-with-content__control-play');
    const soundBtn = container.querySelector('.video-with-content__control-sound');

    if (video || iframe) {
      // Play/Pause control
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          if (playBtn.classList.contains('active')) {
            if (video) {
              video.pause();
            }
            if (iframe) {
              iframe.src = iframe.getAttribute('data-src1');
            }
          } else {
            if (video) {
              video.play();
            }
            if (iframe) {
              iframe.src = iframe.getAttribute('data-src2');
            }
          }
          playBtn.classList.toggle('active');
        });
      }
    }

    // Sound control (video only)
    if (video && soundBtn) {
      soundBtn.addEventListener('click', () => {
        soundBtn.classList.toggle('active');
        if (soundBtn.classList.contains('active')) {
          video.muted = false;
          video.setAttribute('mute', 'false');
        } else {
          video.muted = true;
          video.setAttribute('mute', 'true');
        }
      });
    }

    // Handle video ended event
    if (video) {
      video.addEventListener('ended', function() {
        if (playBtn) {
          playBtn.classList.remove('active');
        }
      });

      // Load video source immediately
      const dataSrc = video.getAttribute('data-src');
      console.log('Video data-src:', dataSrc);

      if (dataSrc) {
        video.src = dataSrc;
        video.removeAttribute('data-src');
        console.log('Video src set to:', video.src);

        // Try to play the video when it's ready
        const playVideo = () => {
          console.log('Attempting to play video, readyState:', video.readyState);
          video.play().then(() => {
            console.log('Video playing successfully');
          }).catch(err => {
            console.log('Autoplay prevented:', err);
          });
        };

        // If video is already loaded enough, play immediately
        if (video.readyState >= 3) {
          console.log('Video already ready, playing now');
          playVideo();
        } else {
          // Otherwise wait for it to be ready
          console.log('Waiting for video to be ready');
          video.addEventListener('canplay', playVideo, { once: true });
        }
      } else {
        console.log('No data-src attribute found on video element');
      }
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoWithContent);
} else {
  initVideoWithContent();
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:unload', initVideoWithContent);
  document.addEventListener('shopify:section:load', initVideoWithContent);
}
